import { Icon } from '@eventbrite/eds-icon';
import {
    ChevronDownChunky,
    ChevronUpChunky,
} from '@eventbrite/eds-iconography';
import React, { FunctionComponent, ReactNode } from 'react';

export interface LinkTextProps {
    text?: ReactNode;
    isExpanded: boolean;
}

export const LinkText: FunctionComponent<LinkTextProps> = ({
    text,
    isExpanded,
}) => {
    const iconType = isExpanded ? <ChevronUpChunky /> : <ChevronDownChunky />;

    return (
        <div className="eds-expansion-panel__link">
            <p>{text}</p>
            <Icon type={iconType} size="small" />
        </div>
    );
};
